<template>
  <v-card
    tile
  >
    <v-img
      :src="cardImage"
      :height="300"
    />
    <v-card-title>
      Prosense ビデオレッスン
    </v-card-title>
    <v-card-subtitle>
      Prosenseオリジナルのプログラミング学習用ビデオ教材
    </v-card-subtitle>
    <v-card-text>
      Prosenseの講師が作成したプログラミング学習用ビデオ教材になります。<span class="font-weight-bold yellow-underline">一部の映像は無料で公開</span>しております。<br/>レベル別にコースを選んで自分に合った教材を選んでプログラミングが学べる！動画は随時追加されます。
    </v-card-text>
    <v-card-actions>
      <router-link to="/video-lessons">
        <v-btn
          color="purple"
          text
        >
          詳細はこちら
        </v-btn>
      </router-link>
    </v-card-actions>
  </v-card>
</template>

<script>
import CardImage from '@/assets/img/video-lessons/video-lesson-main-min.jpg'

export default {
  name: 'VVideoLessonsServiceCard',
  data() {
    return {
      cardImage: CardImage
    }
  }
}
</script>